import React from 'react';
import { Helmet } from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';

interface SeoProps {
  lang: string;
  title: string;
  description?: string;
  thumbnail?: string;
}

const Seo = ({
  lang,
  title,
  description,
  thumbnail,
}: SeoProps) => {
  const { site }: any = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            lang
            url
          }
        }
      }
    `
  );

  const url = site.siteMetadata.url;
  title = title || site.siteMetadata?.title;
  lang = lang || site.siteMetadata.lang;
  description = description || site.siteMetadata.description;
  thumbnail = thumbnail || '';

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      meta={[
        {
          name: `description`,
          content: description,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:url`,
          content: url,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: description,
        },
        {
          property: `og:image`,
          content: url + thumbnail,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          property: `twitter:url`,
          content: url,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: description,
        },
        {
          property: `twitter:image`,
          content: url + thumbnail,
        },
      ]}
    />
  );
};

export default Seo;
